<template>
  <div class="casino-container" id="casinoContainer">
    <casino-user-game-section v-if="isLoggedIn"></casino-user-game-section>
    <div class="casino-wrapper" v-if="allGames && allGames.groups && allGames.groups.length > 0" ref="casinoLobbyRef">
      <casino-group :data-id="i + 1" v-for="(group, i) in visibleGroupList" :key="group.groupId" :group="group" :gamesWithInfoData="allCasinoGamesWithInfoData"></casino-group>
      <p v-if='visibleGroupList.length' id='load-more' :class='loadMoreStatus'></p>
    </div>
  </div>
</template>

<script>
  import store from '@/store'
  import GameDetails from '@/components/gap/GameDetails.vue'
  import Screen from '@/components/mixins/Screen'
  import GeoLocation from '@/components/mixins/GeoLocation'
  import GeolocationIndicator from '@/components/common/GeolocationIndicator.vue'
  import CasinoFooter from '@/components/igaming/partials/CasinoFooter.vue'
  import CasinoSearchBar from '@/components/igaming/partials/casinoSearch/casinoSearchBar.vue'
  import CasinoGroup from '@/components/igaming/partials/casinoGroup.vue'
  import HeadlinesLight from '@/components/sports/bettingoffer/headlinesLight.vue'
  import casinoTestComponent from '@/components/igaming/partials/casinoTestComponent.vue'
  import CasinoLauncherDialog from '@/components/igaming/partials/casinoLauncherDialog.vue'
  import CasinoTopGames from '@/components/igaming/partials/casinoTopGames.vue'
  import CasinoUserGameSection from '@/components/igaming/partials/casinoUserGameSection.vue'

  export default {
    name: 'casinoLobby',
    components: {
      CasinoUserGameSection,
      GameDetails,
      GeolocationIndicator,
      CasinoSearchBar,
      CasinoFooter,
      CasinoGroup,
      HeadlinesLight,
      CasinoLauncherDialog,
      casinoTestComponent,
      CasinoTopGames
    },
    mixins: [
      Screen,
      GeoLocation
    ],
    data () {
      return {
        currentGameId: undefined,
        gamePopup: undefined,
        gameUrl: undefined,
        gameImage: undefined,
        gameLogo: undefined,
        gameName: undefined,
        gameDescription: undefined,
        gameDetailsPopUp: false,
        geoLocationDetails: false,
        secureToken: null,
        initialLoad: true,
        limit: 10,
        loadMoreStatus: '',
        visibleGroupList: [],
        allCasinoGamesWithInfoData: null,
        itemCountLoaded: 0,
        setVisibleGroups: undefined,
        scrollCallback: false,
        casinoLobbyRef: false
      }
    },
    computed: {
      allGames () {
        return store.getters['gap/getAllGamesData']
      },
      username () {
        return store.getters['getUsername']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      }
    },
    methods: {
      loadData () {
        if (!this.allGames) return false
        let allCasinoGroups = this.allGames.groups
        this.setVisibleGroups = allCasinoGroups.slice(this.itemCountLoaded, this.itemCountLoaded + this.limit)
        this.itemCountLoaded = this.itemCountLoaded + this.limit
        this.allCasinoGamesWithInfoData = this.allGames.games
        this.visibleGroupList.push(...this.setVisibleGroups)
        if (this.allGames && this.allGames.games) this.allCasinoGamesWithInfoData = this.allGames.games
        this.loadMoreStatus = this.visibleGroupList.length === allCasinoGroups.length ? 'no-more' : 'idle'
        if (this.initialLoad) {
          this.attachInfiniteLoading()
        }
      },
      attachInfiniteLoading () {
        window.addEventListener('scroll', this.scrollCallback = async evt => {
          this.casinoLobbyRef = this.$refs['casinoLobbyRef']
          if (this.casinoLobbyRef && !this.initialLoad && this.loadMoreStatus === 'idle' && this.casinoLobbyRef.getBoundingClientRect().bottom < window.innerHeight) {
            this.loadMoreStatus = 'loading'
            this.loadData()
          }
        })
        this.initialLoad = false
      },
      resetAll () {
        window.removeEventListener('scroll', this.scrollCallback)
        this.currentGameId = undefined
        this.gamePopup = undefined
        this.gameUrl = undefined
        this.gameImage = undefined
        this.gameLogo = undefined
        this.gameName = undefined
        this.gameDescription = undefined
        this.gameDetailsPopUp = false
        this.geoLocationDetails = false
        this.secureToken = null
        this.tempUniqueUserID = null
        this.initialLoad = true
        this.loadMoreStatus = ''
        this.visibleGroupList = []
        this.itemCountLoaded = 0
        this.setVisibleGroups = undefined
        this.casinoLobbyRef = false
        this.scrollCallback = false
      }
    },
    mounted () {
      this.loadData()
    },
    created () {},
    destroyed () {
      this.resetAll()
    },
    watch: {
      allGames (newVal) {
        if (newVal) {
          this.loadData()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/igaming/CasinoLobby.vue